import React from 'react';

const NotFound = () => (
    <div>
        <p>Not Found!!!!</p>
    </div>
)

export default NotFound;